const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const apiFetch = async (path, { token, method = "GET", body } = {}) => {
    const res = await fetch(`${API}${path}`, {
        method,
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: body ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        const detail = data.detail;
        const message =
            typeof detail === "string"
                ? detail
                : Array.isArray(detail)
                  ? detail.map((e) => e?.msg || "").filter(Boolean).join(" ")
                  : "Request failed";
        const err = new Error(message);
        err.status = res.status;
        throw err;
    }
    return res.json();
};
